import api from '@http/api';

export interface IDoacoes {
  modelo: IDoacoesResultTable[];
  idDoacao: number;
  dataCadastro: string;
  IDCadastro: number;
  NomeCadastro: string;
  Valor: string;
  origemDoacaoDescricao: string;
}

export interface IDoacoesResultTable {
  idDoacao: string;
  IDCadastro: string;
}

class Services {
  public async GetLotesFechados(status: number) {
    return await api
      .get('/api/LoteDoacao/lotes-fechados', {
        params: { status},
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }


  public async GetLoteAbertos() {
    return await api
      .get('/api/LoteDoacao/LotesAbertos')
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async AprovarDoacoes(doacaoIds: number[], observacao: string) {
    return await api
      .post('/api/Doacao/AprovarDoacoes', { doacaoIds, observacao })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async RecusarDoacoes(doacaoIds: number[], observacao: string) {
    return await api
      .post('/api/Doacao/RecusarDoacoes', { doacaoIds, observacao })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async AprovarLote(loteId: number) {
    return await api
      .post( `/api/Doacao/AprovarLote?loteId=${loteId}`, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async RecusarLote(loteId: number) {
    return await api
      .post( `/api/Doacao/RecusarLote?loteId=${loteId}`, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async ReabrirLote(loteId: number, idUsuario: number) {
    return await api
    .post(`/api/LoteDoacao/reabrir/${loteId}?idUsuario=${idUsuario}`)

      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }
}

export default new Services();
